import { api } from "assets/scripts/utilities/api-clients";

export const index = async (options = {}) => {
  const response = await api.get("/audit-logs/", options);

  return response;
};

export const getEntities = async (options = {}) => {
  const response = await api.get("/audit-logs/ents", options);

  return response;
};
